import { GoogleSheetsReconnectButton } from './GoogleSheetsReconnectButton';
import { GoogleSheetsServiceComponent } from './GoogleSheetsServiceComponent';
export const GoogleSheetsReconnectionConfig = {
  reconnectButton: GoogleSheetsReconnectButton,
  serviceComponent: GoogleSheetsServiceComponent
};